import enhanceTextField from "src/common/enhanceTextField";
import { TextField } from "@material-ui/core";

const EnhancedTextField = enhanceTextField(TextField);
export default EnhancedTextField;
